var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7.576 4 4 7.576 4 12C4 16.424 7.576 20 12 20C16.424 20 20 16.424 20 12C20 7.576 16.424 4 12 4ZM15.44 15.44C15.128 15.752 14.624 15.752 14.312 15.44L12 13.128L9.688 15.44C9.376 15.752 8.872 15.752 8.56 15.44C8.248 15.128 8.248 14.624 8.56 14.312L10.872 12L8.56 9.688C8.248 9.376 8.248 8.872 8.56 8.56C8.872 8.248 9.376 8.248 9.688 8.56L12 10.872L14.312 8.56C14.624 8.248 15.128 8.248 15.44 8.56C15.752 8.872 15.752 9.376 15.44 9.688L13.128 12L15.44 14.312C15.744 14.616 15.744 15.128 15.44 15.44Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bc2d9f975f515f627959e882a000df47.svg";
export { ForwardRef as ReactComponent };